/** Excel-friendly CSV download: BOM, semicolons, quoted cells, formula characters neutralised. */
export function downloadCsv(
  filename: string,
  headers: readonly string[],
  rows: ReadonlyArray<readonly string[]>,
): void {
  const cell = (v: string) => `"${v.replace(/^\s*[=+@-]/, "'$&").replaceAll('"', '""')}"`;
  const lines = [headers, ...rows].map((r) => r.map(cell).join(';'));
  const blob = new Blob([`\uFEFF${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
